export const translations = {
  welcomeBio: { en: "Welcome to your professional profile dashboard", ar: "مرحباً بك في لوحة تحكم ملفك المهني" },
  uploading: { en: "Uploading...", ar: "جاري الرفع..." },
  changePhoto: { en: "Change Photo", ar: "تغيير الصورة" },
  invalidFileTitle: { en: "Invalid file", ar: "ملف غير صالح" },
  invalidFileBody: { en: "Please choose an image file.", ar: "يرجى اختيار ملف صورة." },
  fileTooLargeTitle: { en: "File too large", ar: "الملف كبير جدًا" },
  fileTooLargeBody: { en: "The image must be smaller than 5 MB.", ar: "يجب أن يكون حجم الصورة أقل من 5 ميجابايت." },
  photoUpdatedTitle: { en: "Photo updated", ar: "تم تحديث الصورة" },
  photoUpdatedBody: { en: "Your profile picture was updated.", ar: "تم تحديث صورة ملفك الشخصي." },
  photoUploadFailedTitle: { en: "Couldn't update photo", ar: "تعذّر تحديث الصورة" },
  photoUploadFailedBody: { en: "The photo couldn't be uploaded. Please try again.", ar: "تعذّر رفع الصورة. يرجى المحاولة مرة أخرى." },
  personalDetails: { en: "Personal Details", ar: "التفاصيل الشخصية" },
  performance: { en: "Performance", ar: "الأداء" },
  projects: { en: "Projects", ar: "المشاريع" },
  personalInformation: { en: "Personal Information", ar: "المعلومات الشخصية" },
  emailAddress: { en: "Email Address", ar: "البريد الإلكتروني" },
  phoneNumber: { en: "Phone Number", ar: "رقم الهاتف" },
  dateOfBirth: { en: "Date of Birth", ar: "تاريخ الميلاد" },
  nationalId: { en: "National ID", ar: "الرقم القومي" },
  address: { en: "Address", ar: "العنوان" },
  emergencyContact: { en: "Emergency Contact", ar: "جهة الاتصال للطوارئ" },
  employmentDetails: { en: "Employment Details", ar: "تفاصيل التوظيف" },
  employeeId: { en: "Employee ID", ar: "رقم الموظف" },
  joinDate: { en: "Join Date", ar: "تاريخ الانضمام" },
  manager: { en: "Manager", ar: "المدير المباشر" },
  workLocation: { en: "Work Location", ar: "موقع العمل" },
  employmentStatus: { en: "Employment Status", ar: "حالة التوظيف" },
  languages: { en: "Languages", ar: "اللغات" },
  certifications: { en: "Certifications", ar: "الشهادات" },
  recentActivities: { en: "Recent Activities", ar: "الأنشطة الأخيرة" },
  performanceMetrics: { en: "Performance Metrics", ar: "مقاييس الأداء" },
  goalsProgress: { en: "Goals Progress", ar: "تقدم الأهداف" },
  completed: { en: "Completed", ar: "مكتمل" },
  inProgress: { en: "In Progress", ar: "قيد التنفيذ" },
  totalGoals: { en: "Total Goals", ar: "إجمالي الأهداف" },
  achievements: { en: "All Achievements", ar: "جميع الإنجازات" },
  productivity: { en: "Productivity", ar: "الإنتاجية" },
  collaboration: { en: "Collaboration", ar: "التعاون" },
  innovation: { en: "Innovation", ar: "الابتكار" },
  leadership: { en: "Leadership", ar: "القيادة" },
  currentProjects: { en: "Current Projects", ar: "المشاريع الحالية" },
  projectCompleted: { en: "Completed", ar: "مكتمل" },
  projectInProgress: { en: "In Progress", ar: "قيد التنفيذ" },
  projectPlanning: { en: "Planning", ar: "تخطيط" },
  noSkillsYet: { en: "No skills yet", ar: "لا توجد مهارات بعد" },
  noLanguagesYet: { en: "No languages yet", ar: "لا توجد لغات بعد" },
  noCertificationsYet: { en: "No certifications yet", ar: "لا توجد شهادات بعد" },
  employeeOfMonth: { en: "Employee of the Month", ar: "موظف الشهر" },
  innovationAward: { en: "Innovation Award", ar: "جائزة الابتكار" },
  teamLeadership: { en: "Team Leadership Excellence", ar: "التميز في قيادة الفريق" },
  technicalExcellence: { en: "Technical Excellence", ar: "التميز التقني" },
};
